export default __webpack_public_path__ + "static/media/formulario_para_spect-pet.33010823.pdf";